import './Background.css';

const Background = () => {
    return (
        <div>
            <div className="shape1"></div>
            <div className="shape1b"></div>
            <div className="shape2"></div>
            <div className="shape3"></div>
            <div className="shape4"></div>
            <div className="shape5"></div>
            {/*<div className="shape6"></div>*/}
            {/*<div className="shape5"></div>*/}



        </div>

    )
}

export default Background;